<template lang="pug">
  .reviews(v-if="content")
    .page__wr
      PageConstruction(v-if="content.pageConstruction")
      template(v-else)
        Bread(v-if="content.bread", :bread="content.bread")
        .reviews__title(v-if="h1") {{h1}}
        .reviews__items(v-if="content.items")
          .reviews__item(v-for="item in content.items", :key="item.id", :to="item.link")
            .reviews__item-img-wr
              img.reviews__item-img(v-if="item.img", :src="item.img")
            .reviews__item-content
              .reviews__item-name(v-if="item.name") {{item.name}}
              .reviews__item-date(v-if="item.date") {{item.date}}
              .reviews__item-text(v-if="item.text") {{item.text}}
        button.reviews__btn(v-if="more", @click="loadMore") Показать еще
          SvgIcon.reviews__btn-ico(name="loader", width="24", height="24")
        .reviews__bottom
          Form(v-if="content.form", :form="content.form")
          .reviews__bottom-img-wr
            img.reviews__bottom-img(v-if="content.img", :src="content.img")
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/reviews/reviews.styl';

  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import Bread from '@/components/common/bread/bread.vue';
  import Form from '@/components/common/form/form.vue';
  import PageConstruction from '@/components/common/pageConstruction/pageConstruction.vue';

  export default {
    name: 'Reviews',

    mixins: [AjaxHelpersVue],

    data() {
      return {
        content: null,
        more: false
      }
    },

    components: {
      SvgIcon,
      Bread,
      Form,
      PageConstruction
    },

    created() {
      // Загрузка данных для страницы
      EventBus.$on('loadReviewsPage', params => {
        this.request(params.url);
      });
    },

    methods: {
      request(url) {
        this.req('ReviewsPage:getReviewsPage', {url}, res => {
          if(this.checkProperty(res.content)) {
            this.content = res.content;
            this.more = res.content.more;

            this.$nextTick(() => {
              setTimeout(() => {
                this.masonryInit();
                $('.page__items').css('height', $('.page__item--active').outerHeight() + 'px');
              }, 250);
            });
          }
        }, 'reviews');
      },

      masonryInit() {
        if($('.reviews__items').masonry()) {
          $('.reviews__items').masonry('destroy');
        }

        $('.reviews__items').masonry({
          itemSelector: '.reviews__item',
          columnWidth: 368,
          gutter: 32,
          horizontalOrder: true
        });
      },

      loadMore() {
        $('.reviews__btn').addClass('reviews__btn--loading');

        let params = {
          count: this.content.items.length
        };

        this.req('ReviewsPage:getReviewsItems', {...params}, res => {
          if(this.checkProperty(res.content)) {
            this.content.items = this.content.items.concat(res.content.items);
            this.more = res.content.more;

            this.$nextTick(() => {
              $('.reviews__btn').removeClass('reviews__btn--loading');
              this.masonryInit();
              $('.page__items').css('height', $('.page__item--active').outerHeight() + 'px');
            });
          }
        }, '', 'localPageRequest');
      },
    }

  }
</script>
